import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyIdexxneo = lazy(() => import('./svg-components/idexxneo'));

const Idexxneo = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyIdexxneo {...rest} />
  </Suspense>
);

export default Idexxneo;
